<template><div><h1 id="mailingauswertung" tabindex="-1"><a class="header-anchor" href="#mailingauswertung"><span>Mailingauswertung</span></a></h1>
<p>Mailingauswertung — Ereignisauswertung mit definierbaren Dimensionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit Mailingauswertung könmnen zu einem Ereignis fast beliebige Auswertungen mit vordefierten Dimensionen durchgeführt werden.</p>
<p>Die Wahl der Dimensionen und die Gruppierungen der Dimensionswerte wird in den zugehörigen <RouteLink to="/referenz/refs/ft.refdata.eamaildim.html" title="Dimensionen zuordnen">Dimensionen</RouteLink> gemacht.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Mailingauswertung → Mailingauswertung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Ereignis</dt>
<dd>Ereignisnummer für die ein Datenextrakt vorgenommen werden soll.</dd>
<dt>Auswertungsjob</dt>
<dd>Fortlaufende, vom System vergebene Laufnummer, um verschiedene Datenextrakt für das gleiche Ereignis voneinander zu trennen.</dd>
<dt>Datum</dt>
<dd>Das Datum der letzten Ausführung des Jobs.</dd>
<dt>Maximale Laufzeit</dt>
<dd>Maximale Laufzeit des Jobs in Minuten. Werden nur wenige Dimensionen in den Positionen angegeben, dann sollte die Laufzeit nicht länger als 5 Minuten sein.</dd>
<dt>Maximale Anzahl Zeilen</dt>
<dd>Da MS-Excel nur Tabellen bis maximal etwa 64'000 Zeilen unterstützt, kann hier eine Grenze angegeben werden.</dd>
</dl>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Wenn das Programm nach der erreichten Anzahl Zeilen abbricht, können die Daten nicht verwendet werden. Die Option dient der schnellen Kontrolle, dass  die exportierte Anzahl Zeilen nicht die einegebene Grenze erreicht hat.</p>
</div>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="aufbereiten" tabindex="-1"><a class="header-anchor" href="#aufbereiten"><span>aufbereiten</span></a></h3>
<p>Die Funktion exportiert die Daten mit der aktuellen Mailingauswertung.</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Ereignisnummer</dt>
<dd>Nummer des Ereignisses, für die, die Aufbereitung erfolgen soll.</dd>
<dt>Auswertungsjob</dt>
<dd>Nummer des Auswertungsjobs.</dd>
<dt>Ausgabe</dt>
<dd>Standard</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.eamaildim.html" title="Dimensionen zuordnen">Dimensionen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.eadimdef.html" title="Dimensionen definieren">Dimensionen definieren</RouteLink></p>
</div></template>


